/**
 * When a delivery arrives, in the mock-up's words (order to invoice doc 104 §5.5): "Arrives Wed 15 Oct", and for a
 * timed level "Arrives Wed 15 Oct by 12:00". The date and the time are the server's (ready date plus the courier's
 * transit, in working days; `arrives_by` for a timed level); nothing is worked out here. Null when the date is not
 * known.
 */

import { formatWeekdayDateOrDash } from "./formatters";

export function deliveryArrivalSentence(
  arrivesOn: string | null | undefined,
  arrivesBy: string | null | undefined,
): string | null {
  if (!arrivesOn) return null;
  const day = formatWeekdayDateOrDash(arrivesOn);
  if (day === "-") return null;
  return arrivesBy ? `Arrives ${day} by ${arrivesBy}` : `Arrives ${day}`;
}
